import { Suspense } from 'react';

import { Dashboard as DashboardComponent } from '../components/Dashboard';
import Layout from '../components/Layout';

export function Dashboard() {
  return (
    <Layout>
      <Suspense>
        <DashboardComponent />
      </Suspense>
    </Layout>
  );
}
